import { render } from "./ReceiverStat.vue?vue&type=template&id=66bd460d&scoped=true"
import script from "./ReceiverStat.vue?vue&type=script&lang=js"
export * from "./ReceiverStat.vue?vue&type=script&lang=js"

import "./ReceiverStat.vue?vue&type=style&index=0&id=66bd460d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66bd460d"]])

export default __exports__